import { render, staticRenderFns } from "./MainBoard.vue?vue&type=template&id=34dd653a&scoped=true"
import script from "./MainBoard.vue?vue&type=script&lang=js"
export * from "./MainBoard.vue?vue&type=script&lang=js"
import style0 from "./MainBoard.vue?vue&type=style&index=0&id=34dd653a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dd653a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/overseas_platform_beta/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34dd653a')) {
      api.createRecord('34dd653a', component.options)
    } else {
      api.reload('34dd653a', component.options)
    }
    module.hot.accept("./MainBoard.vue?vue&type=template&id=34dd653a&scoped=true", function () {
      api.rerender('34dd653a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MainBoard.vue"
export default component.exports